.assessmentFields {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
}

.buttonContainer {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    margin-top: 24px;
}
